import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { LeftNavigationAccordionGroup } from './LeftNavigationAccordionGroup';
import { LeftNavigationStandard } from './LeftNavigationStandard';
import '../styles/LeftNavigation.scss';

const isAccordion = nav => nav.type === 'accordion';

export function LeftNavigation({ persistedFiltersGroup }) {
    const {
        navigation,
        navigationRelated
    } = useSelector(({ sideNavigation }) => sideNavigation);

    const getMobileChildren = (children, parentId) => {
        if (!children || !children.length) {
            return null;
        }

        let lastChildren = children.filter(item => item.id !== parentId);
        let newLastChildren = null;

        do {
            newLastChildren = lastChildren.find(child => child.selected && !child.isViewAll);

            if (newLastChildren && newLastChildren.id !== parentId) {
                lastChildren = newLastChildren.children;
            }
        } while (newLastChildren && newLastChildren.id !== parentId);

        return lastChildren;
    };

    const groupedMenus = useMemo(() => {
        const primaryMenu = navigation?.find(nav => !isAccordion(nav));
        const relatedAccordionMenus = navigationRelated?.filter(nav => isAccordion(nav));
        const menus = {
            standard: [
                ...(navigation && navigation.length ? navigation : []),
                ...(navigationRelated && navigationRelated.length ? navigationRelated.filter(nav => !isAccordion(nav)) : []),
                ...(relatedAccordionMenus ? [{
                    children: relatedAccordionMenus,
                    type: 'accordion',
                    name: 'relatedAccordionMenus'
                }] : [])
            ],
            mobile: primaryMenu ? getMobileChildren(primaryMenu.children, primaryMenu.navigationId) : []
        };

        return menus;
    }, [navigation, navigationRelated]);

    return (
        <div className="left-navigation">
            {groupedMenus.standard.map(nav => (
                nav.type === 'accordion'
                    ? (
                        <LeftNavigationAccordionGroup
                            key={nav.name}
                            items={nav.children}
                            persistedFiltersGroup={persistedFiltersGroup}
                        />
                    )
                    : (
                        <LeftNavigationStandard
                            key={nav.navigationId || nav.name}
                            item={nav}
                            persistedFiltersGroup={persistedFiltersGroup}
                        />
                    )
            ))}
        </div>
    );
}
